import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlProvider,
  urlProviderSecured,
  urlGetAllProviderSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;

  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get Provider by uuid.
 */
export const getProviderByUuid = createAction("GET_PROVIDER", (param) =>
  apiGet(urlProviderSecured, param, true)()
);

/**
 * Filter list Provider.
 */
export const filterProvider = createAction("FILTER_PROVIDER", (filter, param) =>
  apiGet(urlProviderSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Provider.
 */
export const createProvider = createAction("CREATE_PROVIDER", (obj) =>
  apiPost(urlProviderSecured, obj, undefined, true)()
);

/**
 * Update Provider.
 */
export const modifyProvider = createAction("UPDATE_PROVIDER", (obj, param) =>
  apiPut(urlProviderSecured, obj, param, true)()
);

/**
 * Delete Provider by uuid.
 */
export const removeProvider = createAction("DELETE_PROVIDER", (param) =>
  apiDelete(urlProviderSecured, param, true)()
);

/**
 * Filter list Providers.
 */
export const getAll = createAction("GET_ALL_PROVIDERS", (filters) =>
  apiGet(
    urlGetAllProviderSecured + generateFilterQuery(filters),
    undefined,
    false
  )()
);
